import React, { useState, useRef } from 'react';
import './App.css'
import { useOnClickOutside } from './hooks';
import { Burger, Menu, About, Team, FrontPage, Chatbots, TeachingResources } from './components';
import { BrowserRouter as Router, Route, Switch, withRouter } from "react-router-dom";

import TTS from "./TTS"
import Robot from "./Robot";

import TagManager from 'react-gtm-module'

const tagManagerArgs = {
  gtmId: 'GTM-N9T4QM7'
}

TagManager.initialize(tagManagerArgs)

function App() {
  const [open, setOpen] = useState(false);
  const node = useRef();
  const burgerRef = useRef(null);
  const menuId = "main-menu";

  useOnClickOutside(node, () => setOpen(false));

  return (
    <div ref={node}>
      <Router>
          <div className="nav-container">
            <Burger open={open} setOpen={setOpen} burgerRef={burgerRef} aria-controls={menuId} />
            <Menu open={open} setOpen={setOpen} id={menuId} burgerRef={burgerRef}/>
          </div>
          <Switch>
              <Route path="/About" component={withRouter(About)} />
              <Route path="/Team" component={withRouter(Team)} />
              <Route path="/TTS" component={withRouter(TTS)} />
              <Route path="/Robot" component={withRouter(Robot)} />
              <Route path="/" exact component={withRouter(FrontPage)} />
              <Route path="/Chatbots" component={withRouter(Chatbots)}/>
              <Route path="/TeachingResources" component={
                withRouter(TeachingResources)
              }/>
          </Switch>
      </Router>
    </div>
  );
}

export default App;
